import { createFileRoute } from "@tanstack/react-router";
import AccountSettings from "@/pages/AccountSettings";

export const Route = createFileRoute("/_authenticated/account")({
  head: () => ({
    meta: [
      { title: "Mijn account | De Hussel App" },
      { name: "description", content: "Beheer je profiel, voorkeuren en accountinstellingen." },
      { property: "og:title", content: "Mijn account | De Hussel App" },
      { property: "og:description", content: "Beheer je profiel, voorkeuren en accountinstellingen." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: AccountSettings,
});
